// O deliveryId vem do RadioButtonGroupInput (string) e o da lista é number.
// `+undefined` dá NaN e não casa com nada, então nunca lança.
export const findFillin = (fillins: any[] | null | undefined, deliveryId: unknown) =>
  fillins?.find((f) => f.deliveryId === +(deliveryId as any))

// O abastecimento vai no payload como objeto completo (preço, volume, total), que
// o backend não aceita vir sem verificação. Resolve a partir do `deliveryId` do
// próprio form em vez de estado paralelo: o valor do RHF fica velho quando a lista
// troca (bico, período) e o `find` devolvia undefined -> '"fillin" is required'.
// Não lança: throw no transform vira rejeição não tratada e deixa o botão travado.
export const buildPendingTransactionPayload = (data: Record<string, any>, fillins: any[] | null | undefined) => {
  const { from, to, ...rest } = data;
  const fillin = findFillin(fillins, data.deliveryId);
  return fillin ? { ...rest, fillin } : rest;
};
